import { render } from "./ProposalHeader.vue?vue&type=template&id=486036f4&scoped=true&ts=true"
import script from "./ProposalHeader.vue?vue&type=script&lang=ts"
export * from "./ProposalHeader.vue?vue&type=script&lang=ts"

import "./ProposalHeader.vue?vue&type=style&index=0&id=486036f4&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486036f4"]])

export default __exports__